import { render } from "./ChatWindow.vue?vue&type=template&id=8ca2cbd2"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=8ca2cbd2&lang=css"
script.render = render

export default script